
/**
 * First we will load all of this project's JavaScript dependencies which
 * include Vue and Vue Resource. This gives a great starting point for
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

/**
 * Next, we will create a fresh Angular application instance
 */
const app = angular.module('App', [
    'flsControllers',
    'flsServices',
    'checklist-model',
    'angular-loading-bar',
    'ngAnimate',
]);

/**
 * Finally, make sure we inject the csft token
 * @param  {Object} $httpProvider)}
 * @return {void}
 */
app.config(['$httpProvider', function ($httpProvider) {
    $httpProvider.defaults.headers.common = {
        'X-CSRF-TOKEN': Laravel.csrfToken,
        'X-Requested-With': 'XMLHttpRequest',
      };
}]);
